/**
 * @generated SignedSource<<ae90646d5a8444c8bd4510deafb15985>>
 * @relayHash b26d74a977afd1c1cb5201fbf9d16e1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110

import type { ConcreteRequest } from 'relay-runtime';
export type HelpObjectStoreArticleContentType = "FOLDER" | "PAGE" | "%future added value";
export type csmBreadcrumbsInnerQuery$variables = {
  articleId: string;
  cloudId: string;
  helpCenterAri: string;
};
export type csmBreadcrumbsInnerQuery$data = {
  readonly helpObjectStore_searchArticlesForSupportSite: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors?: ReadonlyArray<{
        readonly id: string;
        readonly title: string | null;
        readonly type: HelpObjectStoreArticleContentType | null;
      }> | null;
      readonly id?: string;
    }> | null;
  } | null;
};
export type csmBreadcrumbsInnerQuery = {
  response: csmBreadcrumbsInnerQuery$data;
  variables: csmBreadcrumbsInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articleId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "articleIds.0",
            "variableName": "articleId"
          }
        ],
        "kind": "ListValue",
        "name": "articleIds"
      },
      {
        "kind": "Literal",
        "name": "expand",
        "value": [
          "ANCESTORS"
        ]
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "concreteType": "HelpObjectStoreArticleRelative",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "type"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreSupportSiteArticleSearchResult"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmBreadcrumbsInnerQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmBreadcrumbsInnerQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110",
    "metadata": {},
    "name": "csmBreadcrumbsInnerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc0a03b251b6289b521688cdb7d387f1";

export default node;
